module.exports = __webpack_public_path__ + "img/collectiongallery_forestgreen.edaba30.jpg";